const getCookie = (name) => {
  const regex = new RegExp(
    `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1")}=([^;]*)`
  );
  const matches = regex.exec(document.cookie);
  return matches ? decodeURIComponent(matches[1]) : null;
};
var CookieTypes = /* @__PURE__ */ ((CookieTypes2) => {
  CookieTypes2["preferredLanguage"] = "preferred-language";
  CookieTypes2["preferredLanguageSPA"] = "preferred-language-client";
  CookieTypes2["unicBrowserCode"] = "ubc-code";
  return CookieTypes2;
})(CookieTypes || {});
const setCookie = (name, value, options = {}) => {
  var _a;
  const cookieOptions = { path: "/", ...options };
  if ((_a = cookieOptions.expires) == null ? void 0 : _a.toUTCString) {
    cookieOptions.expires = cookieOptions.expires.toUTCString();
  }
  let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(
    value
  )}`;
  for (const optionKey in cookieOptions) {
    if (cookieOptions.hasOwnProperty(optionKey)) {
      updatedCookie += `; ${optionKey}`;
      const optionValue = cookieOptions[optionKey];
      if (optionValue !== true) {
        updatedCookie += `=${optionValue}`;
      }
    }
  }
  document.cookie = updatedCookie;
};
const deleteCookie = (name) => {
  setCookie(name, "", { "max-age": -1 });
};
const expireCookie = (value) => {
  const time = value || 15 * 60 * 1e3 * 1e5;
  return new Date((/* @__PURE__ */ new Date()).getTime() + time);
};
export {
  CookieTypes,
  deleteCookie,
  expireCookie,
  getCookie,
  setCookie
};
